import styles from "./style.module.css";
import { useTranslation } from "react-i18next";
import { Intro, MobileIntro } from "src/assets";
import { DynamicTariffVideo } from "src/assets";
import { Stack, useTheme } from "@mui/material";
import { useContext, useRef, useState } from "react";
import { Logo, LogoSMA, LichtBlickLogoSMA } from "src/assets";
import BoldTitle from "src/components/Displays/BoldTitle";
import { ThemeValues } from "src/components/ThemeUsage/theme";
import { ThemeContext } from "src/components/ThemeUsage/ThemeUsage";

const Header = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const videoRef = useRef<HTMLVideoElement>(null);
  const themeName = useContext(ThemeContext);

  const [showVideo, setShowVideo] = useState({
    width: "0px",
    height: "0px",
  });

  document.addEventListener("fullscreenchange", (event) => {
    if (document.fullscreenElement === null) {
      videoRef.current?.pause();
      setShowVideo({
        width: "0px",
        height: "0px",
      });
    }
  });

  if (videoRef.current) {
    videoRef.current.onpause = function () {
      if (videoRef.current?.seeking) {
        return;
      }
      videoRef.current?.pause();
      setShowVideo({
        width: "0px",
        height: "0px",
      });
    };
  }

  const getLogo = () => {
    switch (themeName) {
      case ThemeValues.SMA:
        return <LogoSMA />;
      case ThemeValues.default:
        return <Logo color={"black"} />;
      default:
        return <></>;
    }
  };

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="flex-start"
        width="100%"
        my={4}
        px={{ xs: 0, sm: 2 }}
        ml={{ xs: -6, sm: 0 }}
        spacing={0}
      >
        <Stack
          sx={{
            height: { xs: 30, sm: 50 },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {getLogo()}
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          spacing={0}
          sx={{
            marginLeft: { xs: -4, sm: 2 },
            height: { xs: 30, sm: 50 },
            width: "auto",
          }}
        >
          <LichtBlickLogoSMA color="black" />
        </Stack>
      </Stack>

      <video
        ref={videoRef}
        className={styles}
        width={showVideo.width}
        height={showVideo.height}
        style={{ marginBottom: showVideo.height === "0px" ? "0px" : "10px" }}
      >
        <source src={DynamicTariffVideo} type="video/mp4" />
      </video>

      <Stack
        sx={{
          alignItems: "center",
          width: "fit-content",
          height: "fit-content",
          maxHeight: "fit-content",
          position: "relative",
          borderRadius: "15px",
          overflow: "hidden",
        }}
      >
        <Stack
          sx={{
            display: { xs: "none", sm: "flex" },
          }}
        >
          <img
            src={Intro}
            alt="mobile-intro"
            style={{
              width: "100%",
              height: "100%",
            }}
          />
          <Stack
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              height: "250px",
              background:
                "linear-gradient(to top, rgba(0, 0, 0, 0.888), transparent)",
            }}
          />
        </Stack>
        <Stack
          sx={{
            display: { xs: "flex", sm: "none" },
          }}
        >
          <img
            src={MobileIntro}
            alt="mobile-intro"
            style={{
              width: "100%",
              height: "100%",
            }}
          />
          <Stack
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              height: "250px",
              background:
                "linear-gradient(to top, rgba(0, 0, 0, 0.888), transparent)",
            }}
          />
        </Stack>
        <Stack
          gap={2}
          sx={{
            maxWidth: { xs: "350px", lg: "400px" },
            position: "absolute",
            left: { lg: "201px", md: "100px", sm: "0px" },
            bottom: "29px",
            px: { xs: 4, lg: 0 },
          }}
        >
          <BoldTitle
            color={theme.palette.app.contrast}
            sx={{
              fontSize: { xs: "36px", md: "48px" },
              lineHeight: { xs: "39px", md: "50px" },
            }}
            text={t("page.introduction.newTitleSMA")}
          />

          <BoldTitle
            color={theme.palette.app.contrast}
            sx={{
              fontSize: { xs: "24px", md: "36px" },
              lineHeight: { xs: "27px", md: "38px" },
            }}
            text={t("page.introduction.subtitleSMA")}
          />
        </Stack>
      </Stack>
    </>
  );
};

export default Header;
